import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Select, Typography, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import t from "../../../../languages/pl";

const useStyles = theme => ({
    container: {
        margin: theme.spacing(2)
    },
    content: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4)
    },
    select: {
        minWidth: 140,
        margin: theme.spacing(1)
    }
});

const Reminder = props => {
    const { classes, title, before, value1, value2, onChange1, onChange2 } = props;

    const printOptions = () => {
        let options = [];
        for (let i = 1; i < 100; i++) {
            let value = i.toString();
            if (before === 'before') {
                options.push(<MenuItem key={i} value={i}>{value}&nbsp;{i === 1 ? t.dayBefore : t.daysBefore}</MenuItem>);
            } else {
                options.push(<MenuItem key={i} value={i}>{value}&nbsp;{i === 1 ? t.dayAfter : t.daysAfter}</MenuItem>);
            }
        }
        return options;
    };


    return (
        <div className={classes.container}>
            <Typography variant="body1">
                {title}
            </Typography>
            <div className={classes.content}>
                <FormControl className={classes.select}>
                    <InputLabel>
                        {t.reminder1}
                    </InputLabel>
                    <Select
                        defaultValue=""
                        value={value1}
                        onChange={e => onChange1 && onChange1(e.target.value)}
                    >
                        {printOptions()}
                    </Select>
                </FormControl>
                <FormControl className={classes.select}>
                    <InputLabel>
                        {t.reminder2}
                    </InputLabel>
                    <Select
                        defaultValue=""
                        value={value2}
                        onChange={e => onChange2 && onChange2(e.target.value)}
                    >
                        {printOptions()}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
};

Reminder.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    before: PropTypes.string,
    value1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange1: PropTypes.func,
    onChange2: PropTypes.func
};

export default withStyles(useStyles)(Reminder);
